export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-info-a8703e056d8f5014dbe55aa79e1f437b.svg";